var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.165 14.697C11.7725 14.697 14.697 11.7725 14.697 8.165C14.697 4.55748 11.7725 1.633 8.165 1.633C4.55748 1.633 1.633 4.55748 1.633 8.165C1.633 11.7725 4.55748 14.697 8.165 14.697ZM8.165 16.33C12.6744 16.33 16.33 12.6744 16.33 8.165C16.33 3.65559 12.6744 0 8.165 0C3.65559 0 0 3.65559 0 8.165C0 12.6744 3.65559 16.33 8.165 16.33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16806 3.26367C8.619 3.26367 8.98456 3.62923 8.98456 4.08017V7.82447L10.7867 9.62657C11.1055 9.94543 11.1055 10.4624 10.7867 10.7813C10.4678 11.1001 9.95082 11.1001 9.63196 10.7813L7.59071 8.74002C7.43759 8.5869 7.35156 8.37922 7.35156 8.16267V4.08017C7.35156 3.62923 7.71712 3.26367 8.16806 3.26367Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconWhite);
export default __webpack_public_path__ + "static/media/clock-icon-white.b27d4157a73e37de57bdb67fa622f40e.svg";
export { ForwardRef as ReactComponent };